export function BrandMark() {
  return (
    <svg
      className="brand-mark"
      data-collectie-mark="true"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <path
        d="M 50.45 15.93 A 25 25 0 1 0 50.45 48.07 A 5.25 5.25 0 0 0 42.41 41.32 A 14.5 14.5 0 1 1 42.41 22.68 A 5.25 5.25 0 0 0 50.45 15.93 Z"
        fill="currentColor"
      />
      <circle className="brand-mark-stamp" cx="49" cy="32" r="5.4" />
    </svg>
  );
}
